// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"118":"b5a5b377","300":"15b8bdd1","334":"965bcd9d","353":"3c07f4b0","367":"c10c1f2a","840":"0db3f1a5","871":"caee00ac","990":"4279909a"}[chunkId] + ".chunk.js";
};